import {
    takeLatest, all, put, call,
} from 'redux-saga/effects';
import API from '../common/API';
import * as Actions from '../actions/SurveyManagement';
import { waitAuthorizedCheck } from './Auth';

function* getSurvey(action) {
    try {
        const response = yield call(
            API.get, {
                endpoint: `/api/v1/event/${action.payload}/survey/`,
            },
        );
        yield put(Actions.GetSurveyReceived(response));
    } catch (error) {
        yield put(Actions.GetSurveyReceiveFailure(yield error));
    }
}

function* updateSurvey(action) {
    try {
        const credential = yield call(waitAuthorizedCheck);
        const response = yield call(
            API.post,
            {
                endpoint: `/api/v1/event/${action.payload.shortName}/survey/`,
                body: action.payload.data,
                token: credential.data.token,
            },
        );
        yield put(Actions.UpdateSurveyReceived(response));
    } catch (error) {
        yield put(Actions.UpdateSurveyReceiveFailure(yield error));
    }
}
export default function* SurveyManagement() {
    yield all([
        takeLatest('GET_SURVEY_REQUESTED', getSurvey),
        takeLatest('UPDATE_SURVEY_REQUESTED', updateSurvey),
    ]);
}
